import axios from "axios"
import useSWR from "swr"

const fetcher = async (url, params) => {
    return await axios.get(url, { params }).then(res => res.data.data)
}

const useBranchesByUser = (params) => {
    const { data, error, mutate } = useSWR([`${process.env.REACT_APP_GENERIC_API_URL}/branch/by`, params], fetcher)

    return {
        data,
        isLoading: !error && !data,
        error,
        mutate
    }
}

export default useBranchesByUser